<template>
  <TableLayout :permissions="['business:notice:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" >
      <el-form-item label="标题" prop="title">
        <el-input v-model="searchForm.title" placeholder="请输入标题" clearable @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:notice:create', 'business:notice:delete']">
        <li><el-button type="primary" @click="$refs.operaNoticeWindow.open('新建消息通知')" icon="el-icon-plus" v-permissions="['business:notice:create']">新建</el-button></li>
        <li><el-button  type="danger"  @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:notice:delete']">删除</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- <el-table-column prop="id" label="主键" align="center" min-width="100px"></el-table-column> -->
        <el-table-column prop="title" label="标题" align="center" min-width="120px"></el-table-column>
        <el-table-column prop="content" label="内容" align="center" min-width="380px"></el-table-column>
        <!-- <el-table-column prop="objMemberId" label="关联用户编码（关联member表）" min-width="100px"></el-table-column> -->
        <!-- <el-table-column prop="objMemberImg" label="关联用户头像" min-width="100px"></el-table-column> -->
        <!-- <el-table-column prop="imgurl" label="列表图" min-width="100px"></el-table-column>
        <el-table-column prop="objId" label="对象编码" min-width="100px"></el-table-column> -->
<!--        <el-table-column prop="notifyObject" label="通知对象" align="center" min-width="100px">
          <template slot-scope="{row}">
            {{ row.notifyObject==0 ? '用户' : '商家' }}
          </template>
        </el-table-column>-->
        <!-- <el-table-column prop="type" label="消息类型 0订单通知 1系统消息 2互动消息 3优惠券提醒 4官方客服  5活动推荐 6我的关注" min-width="100px"></el-table-column> -->
        <el-table-column prop="createDate" label="创建时间" align="center" min-width="140px"></el-table-column>
        <el-table-column prop="creatorName" label="创建人" align="center" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:notice:update', 'business:notice:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
          align="center"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaNoticeWindow.open('编辑消息通知', row)" icon="el-icon-edit" v-permissions="['business:notice:update']">编辑</el-button>
            <el-button type="text"  style="color: red;" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:notice:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaNoticeWindow ref="operaNoticeWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaNoticeWindow from '@/components/business/OperaNoticeWindow'
export default {
  name: 'Notice',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaNoticeWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        remark: '',
        memberId: '',
        title: '',
        content: '',
        objMemberId: '',
        objMemberImg: '',
        imgurl: '',
        objId: '',
        objType: '',
        type: '',
        status: ''
      }
    }
  },
  created () {
    this.config({
      module: '消息通知信息表',
      api: '/business/notice',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
